/*                              @Author : {}
* Copyright (c) 2021, by Tush Entertainment
* Permission to use, copy, modify or distribute this software in binary or source form
* for any purpose is allowed only under explicit prior consent in writing from Tush Entertainment.
* THE SOFTWARE IS PROVIDED "AS IS" AND TUSH ENTERTAINMENT DISCLAIMS
* ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
* WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL TUSH ENTERTAINMENT
* BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
* DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR
* PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS
* ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS
* SOFTWARE.THIS SOFTWARE IS PROTECTED BY COPYRIGHT LAWS FROM INDIA AND USA.
* ANY OR ALL PART OF THIS SOFTWARE OR SOURCES CANNOT BE USED FOR ANY TYPES OF
* PRODUCTS WHICH IS DIRECTLY AND INDIRECTLY AFFECTING THE LIFE OF HUMANS.
*/



import React, { useEffect, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Spin from '../Spinner/Spin';
const Userschart = ({registerUserData,loading}) => {
  const [data, setData] = useState([]);
  const [showUserChart, setShowUserChart] = useState(true);
  const toggleUserChart = () => {
    setShowUserChart(!showUserChart);
  };

  return (
    <>
      <div className='graphsme'>
        <div className='graphsme01'>
          <p>
            <h5>Registered User Data</h5>
            <span onClick={toggleUserChart}>{showUserChart ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon/>}</span>
          </p>
          {showUserChart && registerUserData && !loading ?
            <div className='graphsme02'>
              <p>
                <span>Today's Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.todayRegisteredUser && registerUserData.todayRegisteredUser[0]
                    ? registerUserData.todayRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Yesterday's Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.yesterdayRegisteredUser && registerUserData.yesterdayRegisteredUser[0]
                    ? registerUserData.yesterdayRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Weekly Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.weeklyRegisteredUser && registerUserData.weeklyRegisteredUser[0]
                    ? registerUserData.weeklyRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Biweekly Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.biweeklyRegisteredUser && registerUserData.biweeklyRegisteredUser[0]
                    ? registerUserData.biweeklyRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Monthly Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.monthlyRegisteredUser && registerUserData.monthlyRegisteredUser[0]
                    ? registerUserData.monthlyRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Quarterly Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.quarterlyRegisteredUser && registerUserData.quarterlyRegisteredUser[0]
                    ? registerUserData.quarterlyRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Annual Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.annualRegisteredUser && registerUserData.annualRegisteredUser[0]
                    ? registerUserData.annualRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
              <p>
                <span>Life Registered User count:&nbsp;</span>
                <b>
                  {registerUserData.lifeRegisteredUser && registerUserData.lifeRegisteredUser[0]
                    ? registerUserData.lifeRegisteredUser[0].count
                    : "NA"}
                </b>
              </p>
            </div>:
          <div className="spindefault">
          <Spin/>
          </div>}
        </div>
      </div>
    </>
  )
}

export default Userschart;




// import React, { useEffect, useState } from 'react';
// import sampler from '../../Objects/axiosjson';
// import "../../css/graphsme.css";
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// const Userschart = () => {
//   const [data, setData] = useState([]);
//   const [registerUserData, setRegisterUserData] = useState(null);
//   const [showuserchart, setShowuserchart] = useState(true);

//   useEffect(() => {
//     const fetchData = () => {
//       sampler.get('/dashboardJalwa')
//         .then(res => {
//           setData(res.data.data);
//           if (res.data.data && res.data.data.registeredUser) {
//             setRegisterUserData(res.data.data.registeredUser);
//           }
//         }).catch(error => {
//           console.error('Error fetching data:', error);
//         });
//     };
//     fetchData();
//   }, []);

//   const toggleuserchart = () => {
//     setShowuserchart(!showuserchart);
//   };

//   return (
//     <>
//       <div className='graphsme'>
//         <div className='graphsme01'>
//           <p>
//             <h5>Registered User Data</h5>
//             <span onClick={toggleuserchart}>{showuserchart ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon/>}</span>
//           </p>
//           {showuserchart && registerUserData ? (
//             <div className='graphsme02'>
//               <p><span>Today's RegisteredUser count:&nbsp;</span><b>{registerUserData.todayregisteredUser[0].count}</b></p>
//               <p><span>Yesterday's RegisteredUser count:&nbsp;</span><b>{registerUserData.yesterdayregisteredUser[0].count}</b></p>
//               <p><span>Weekly RegisteredUser count:&nbsp;</span><b>{registerUserData.weeklyRegisteredUser[0].count}</b></p>
//               <p><span>Biweekly RegisteredUser count:&nbsp;</span><b>{registerUserData.biweeklyRegisteredUser[0].count}</b></p>
//               <p><span>Monthly RegisteredUser count:&nbsp;</span><b>{registerUserData.monthlyRegisteredUser[0].count}</b></p>
//               <p><span>Quarterly RegisteredUser count:&nbsp;</span><b>{registerUserData.quarterlyRegisteredUser[0].count}</b></p>
//               <p><span>Annual RegisteredUser count:&nbsp;</span><b>{registerUserData.annualRegisteredUser[0].count}</b></p>
//               <p><span>Life RegisteredUser count:&nbsp;</span><b>{registerUserData.lifetTimeInstalleduser[0].count}</b></p>
//             </div>
//           ) : (
//             <div className='graphsme02'>
//               <p>NA</p>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   )
// }

// export default Userschart;



// import React,{useEffect,useState} from 'react';
// import sampler from '../../Objects/axiosjson';
// import "../../css/graphsme.css";
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// const Userschart = () => {
//   const [data, setData] = useState([]);
//   const [registerUserData, setRegisterUserData] = useState(null)

//   useEffect(()=>{
//     const addconfig=()=>{
//       sampler.get('/dashboardJalwa')
//       .then(res=> {
//         setData(res.data.data);
//         if (res.data.data && res.data.data.registeredUser) {
//           setRegisterUserData(res.data.data.registeredUser);
//         }
//       }).catch(error=>{
//         console.error('Error fetching data:', error);
//       })
//     }
//     addconfig();
//   },[])

//   const [showuserchart, setShowuserchart] = useState(true);
//   const toggleuserchart = () => {
//     setShowuserchart(!showuserchart);
//   };

//   return (
//     <>
//        <div className='graphsme'>
//         <div className='graphsme01'>
//           <p>
//             <h5>Registered User Data</h5>
//             <span onClick={toggleuserchart}>{showuserchart ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon/>}</span>
//           </p>
//           {showuserchart && registerUserData && (
//             <div className='graphsme02'>
//               <p><span>Today's RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.todayregisteredUser[0].count}</b></span></p>
//               <p><span>Yesterday's RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.yesterdayregisteredUser[0].count}</b></span></p>
//               <p><span>Weekly RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.weeklyRegisteredUser[0].count}</b></span></p>
//               <p><span>Biweekly RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.biweeklyRegisteredUser[0].count}</b></span></p>
//               <p><span>Monthly RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.monthlyRegisteredUser[0].count}</b></span></p>
//               <p><span>Quarterly RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.quarterlyRegisteredUser[0].count}</b></span></p>
//               <p><span>Annual RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.annualRegisteredUser[0].count}</b></span></p>
//               <p><span>Life RegisteredUser count:&nbsp;</span>  <span><b>{registerUserData.lifetTimeInstalleduser[0].count}</b></span></p>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   )
// }


// export default Userschart;
